import type {ReactElement} from 'react';
import React from 'react';
import {BaseRemoveColorOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-remove-color-option';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetKeyFromEffectsActiveItem} from '@Hooks/poster-editor/useGetKeyFromEffectsOfActiveItem';

interface ItemRemoveColorOptionProps {
  onClickColorFill(): void;
}

export function ItemRemoveColorOption({...props}: ItemRemoveColorOptionProps): ReactElement<any> | null {
  const activeItemId = useSingleActivePosterItemId() ?? '';
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const activeItemRemoveColor = useGetKeyFromEffectsActiveItem('removeColor');
  const activeItemRemoveColorThickness = useGetKeyFromEffectsActiveItem('removeColorThickness');
  const activeItemRemoveColorValue = useGetKeyFromEffectsActiveItem('removeColorValue');

  if (!activeItem) {
    throw new Error('Active item does not exist in remove color option');
  }

  if ((activeItem && !('effects' in activeItem)) || !activeItemRemoveColorValue || activeItemRemoveColorThickness === undefined || activeItemRemoveColor === undefined) {
    throw new Error(`Item doesn't have effects property`);
  }

  if ((activeItem?.isImage() && activeItem.isDrawing()) || activeItem.isSticker()) {
    return null;
  }

  const onToggleRemoveColor = (): void => {
    void activeItem.updateFromObject({
      effects: {
        removeColor: !activeItemRemoveColor,
      },
    });
  };

  const updateTolerance = (updatedValue: number, undoable = true): void => {
    void activeItem.updateFromObject(
      {
        effects: {
          removeColorThickness: updatedValue,
        },
      },
      {
        undoable,
      }
    );
  };

  return (
    <BaseRemoveColorOption
      removeColorThickness={activeItemRemoveColorThickness}
      removeColor={activeItemRemoveColor}
      removeColorValue={activeItemRemoveColorValue}
      onClickColorFill={(): void => {
        props.onClickColorFill();
      }}
      onToggleRemoveColor={onToggleRemoveColor}
      updateTolerance={updateTolerance}
    />
  );
}
